<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15.5 20.05V11h-1v9.05a2.5 2.5 0 101 0z"/><path d="M19 17.38V7a4 4 0 00-8 0v10.38a6.5 6.5 0 108 0zM17.83 26a4.5 4.5 0 11-5.28-7.27l.45-.3V7a2 2 0 014 0v11.44l.45.29a4.5 4.5 0 01.38 7.27zM22 7h4a1 1 0 000-2h-4a1 1 0 000 2zM26 10h-4a1 1 0 000 2h4a1 1 0 000-2zM26 15h-4a1 1 0 000 2h4a1 1 0 000-2z"/></svg>